<!-- 需求发布 -->
<template>
  <div class="issue">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/release' }">供需市场</el-breadcrumb-item>
        <el-breadcrumb-item>发布需求</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="sunForm">
      <div class="formCon width">
        <div class="formConLeft">
          <img class="one" src="../assets/images/u5.png" alt srcset />
          <img class="two" src="../assets/images/flow.png" alt srcset />
        </div>
        <div class="formConRight">
          <el-form ref="issueForm" :model="issueForm" :rules="rules" label-width="120px">
            <el-form-item label="选择类别" prop="type" style="text-align: left;">
              <el-radio-group v-model="issueForm.type">
                <el-radio-button label="1">软件系统</el-radio-button>
                <el-radio-button label="2">硬件系统</el-radio-button>
                <el-radio-button label="3">智能设备</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="需求标题" prop="title">
              <el-input v-model="issueForm.title"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="issueForm.contacts"></el-input>
            </el-form-item>
            <el-form-item label="联系手机" prop="phone">
              <el-input v-model="issueForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱" prop="email">
              <el-input v-model="issueForm.email"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="corporate">
              <el-input v-model="issueForm.corporate"></el-input>
            </el-form-item>
            <el-form-item label="结束时间" prop="end_time">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="issueForm.end_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="详细需求描述" prop="content">
              <el-input type="textarea" v-model="issueForm.content"></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked">
                我已阅读并同意
                <a href="javascript:;" @click="$router.push('/secret')">《隐私协议》</a>
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('issueForm')">确认提交</el-button>
              <el-button @click="resetForm('issueForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    var checkPhone = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/

        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    return {
      topImg: {
        title: '需求管理',
        bgImg: require('../assets/images/u0.jpg'),
        content:
          '软硬件服务需求市场，致力于降低企业成本 使用维护可靠便捷 服务专业到位',
        bl: false,
      },
      issueForm: {
        codes: sessionStorage.getItem('codes'),
        type: '',
        contacts: '',
        title: '',
        content: '',
        phone: '',
        corporate: '',
        end_time: '',
        email: '',
      },
      rules: {
        type: [
          {
            required: true,
            message: '请至少选择一个类别',
            trigger: 'change',
          },
        ],
        title: [{ required: true, message: '请输入需求标题', trigger: 'blur' }],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱' },
          { validator: checkEmail, trigger: 'blur' },
        ],
        corporate: [
          { required: true, message: '请输入需求描述', trigger: 'blur' },
        ],
        end_time: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        content: [
          { required: true, message: '请输入需求描述', trigger: 'blur' },
        ],
      },

      checked: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    submitForm(formName) {
      if (this.checked) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            const res = await this.$http.post('/addDemand', this.issueForm)
            if (res.data.code == 0) {
              this.$message({
                message: res.data.message,
                type: 'success',
              })
            } else {
              this.$message.error(res.data.message)
            }
          } else {
            // console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message({
          message: '请先阅读并同意协议',
          type: 'warning',
        })
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>
<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.formCon {
  background-color: #fff;
  display: flex;
  padding: 10px 20px;
  box-sizing: border-box;
  .formConLeft {
    flex: 1;
    img {
      width: 100%;
      max-width: 656px;
    }
    .two {
      margin-top: 10px;
    }
  }
  .formConRight {
    flex: 1;
    .el-form-item {
      text-align: center;
      a {
        text-decoration: none;
      }
      a:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
